export interface BaseLegalJson {
  Id: number;
  Nome: string;
  Descricao: string;
}

export class BaseLegal {
    Id: number
    Nome: string
    Descricao: string

    constructor(obj?: BaseLegalJson) {
        if (obj) {
            this.Id = obj.Id;
            this.Nome = obj.Nome;
            this.Descricao = obj.Descricao;
        }
    }

    get descDropdown(): string {
        return `${this.Nome} (${this.Descricao})`;
    }
}